// js校验数据类型
export class CheckDataType {
    private static dataType: { [key: string]: string };

    static init(type: string): string | false {
        // 校验的数据类型
        this.dataType = {
            string: 'string',
            number: 'number',
            boolean: 'boolean',
            null: 'null',
            undefined: 'undefined',
            symbol: 'symbol',
            object: 'object',
            array: 'array',
            regexp: 'regexp',
            function: 'function',
            promise: 'promise',
        };
        return (type in this.dataType && this.dataType.hasOwnProperty(type) && this.dataType[type]) || false;
    }
    static isString(data: any): boolean {
        return this.init('string') && this.init('string') === this.checkType(data) ? true : false;
    }
    static isNumber(data: any): boolean {
        return this.init('number') && this.init('number') === this.checkType(data) ? true : false;
    }
    static isBoolean(data: any): boolean {
        return this.init('boolean') && this.init('boolean') === this.checkType(data) ? true : false;
    }
    static isNull(data: any): boolean {
        return this.init('null') && this.init('null') === this.checkType(data) ? true : false;
    }
    static isUndefined(data: any): boolean {
        return this.init('undefined') && this.init('undefined') === this.checkType(data) ? true : false;
    }
    static isSymbol(data: any): boolean {
        return this.init('symbol') && this.init('symbol') === this.checkType(data) ? true : false;
    }
    static isObject(data: any): boolean {
        return this.init('object') && this.init('object') === this.checkType(data) ? true : false;
    }
    static isArray(data: any): boolean {
        return this.init('array') && this.init('array') === this.checkType(data) ? true : false;
    }
    static isRegexp(data: any): boolean {
        return this.init('regexp') && this.init('regexp') === this.checkType(data) ? true : false;
    }
    static isFunction(data: any): boolean {
        return this.init('function') && this.init('function') === this.checkType(data) ? true : false;
    }
    static isPromise(data: any): boolean {
        return this.init('promise') && this.init('promise') === this.checkType(data) ? true : false;
    }
    static checkType(data: any): string {
        return Object.prototype.toString.call(data).toLowerCase().slice(8, -1);
    }
    static isNaN(data: any): boolean {
        return isNaN(data);
    }
    static isStringNumber(data: any): boolean {
        return !isNaN(parseFloat(data));
    }
}

export const isEmptyObject = (object: Record<string, any>): boolean => {
    let empty = false;
    if (!(object instanceof Object)) {
        object = {};
    }
    empty = Reflect.ownKeys(object).length === 0;
    return empty;
};

export const isEmptyValue = (value: any): boolean => {
    return value == null || value === '';
};
